import { render } from "./PublicNotes.vue?vue&type=template&id=0658c793"
import script from "./PublicNotes.vue?vue&type=script&lang=js"
export * from "./PublicNotes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__